import * as React from "react";
import clsx from "clsx";
import PillButton from "./PillButton";
import { IconName } from "@fortawesome/fontawesome-common-types";

export type SelectOption = {
  value: string;
  label: string;
  selected?: boolean;
  icon?: IconName;
};

type ComboBoxDisplayProps = {
  selectedOptions: SelectOption | SelectOption[];
  placeHolder: string;
  query: string;
  setQuery: Function;
  removeSelection: Function;
  isMulti?: boolean;
  error?: boolean;
  value?: SelectOption | SelectOption[];
  warning?: boolean;
};
const ComboBoxDisplay: React.FC<ComboBoxDisplayProps> = ({
  selectedOptions,
  placeHolder,
  query,
  setQuery,
  isMulti,
  value,
  removeSelection,
  error,
  warning,
}) => {
  const classes = error
    ? "bg-[#db271b]/25 border-[#db271b]"
    : warning
    ? "bg-[#f1b825]/25 border-[#f1b825]"
    : "!bg-panel border-gray-300";
  if (isMulti) {
    var pillDisplays: any = [];
    var extraSelected = 0;
    {
      ((value || selectedOptions) as SelectOption[]).forEach(
        (option, index) => {
          if (index < 3) {
            pillDisplays.push(
              <PillButton
                key={`${option.value}-${index}`}
                text={option.label}
                removeSelection={() => removeSelection(option.value)}
              />
            );
          } else {
            extraSelected++;
          }
        }
      );
    }
    return (
      <div
        className={clsx(
          "flex",
          "w-full",
          "space-x-1",
          "overflow-hidden",
          "rounded-lg",
          "border",
          "py-2",
          "pl-3",
          "pr-5",
          "text-sm",
          "leading-5",
          "focus:ring-0",
          classes
        )}
      >
        {pillDisplays.length > 0 && (
          <div
            className={clsx(
              "flex",
              "flex-wrap",
              "w-full",
              "space-x-1",
              "space-y-1",
              "rounded-lg",
              classes
            )}
          >
            {pillDisplays}
            {extraSelected > 0 && (
              <PillButton text={`+${extraSelected.toString()}`} />
            )}
          </div>
        )}
        <input
          className={clsx(
            "flex",
            "w-full",
            "rounded-lg",
            "bg-transparent",
            "px-3",
            "text-sm",
            "leading-5",
            "!outline-none"
          )}
          onChange={(e) => setQuery(e.target.value)}
          value={query}
          placeholder={placeHolder}
        />
      </div>
    );
  } else {
    const displayValue = (value || selectedOptions) as SelectOption;
    return (
      <div
        className={clsx(
          "flex",
          "w-full",
          "space-x-1",
          "rounded-lg",
          "border",
          "py-2",
          "pl-3",
          "pr-5",
          "text-sm",
          "leading-5",
          "focus:ring-0",
          classes
        )}
      >
        {displayValue.label && (
          <span className={clsx("whitespace-nowrap")}>
            {displayValue.label}
          </span>
        )}

        {!(selectedOptions as SelectOption).value && (
          <input
            className={clsx(
              "flex",
              "w-full",
              "rounded-lg",
              "bg-transparent",
              "px-3",
              "text-sm",
              "leading-5",
              "!outline-none",
              error
                ? "placeholder-[#db271b]"
                : warning
                ? "placeholder-[#f1b825]"
                : ""
            )}
            onChange={(e) => setQuery(e.target.value)}
            value={query}
            placeholder={placeHolder}
          />
        )}
      </div>
    );
  }
};

export default ComboBoxDisplay;
